import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { initializeFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";
import { getFunctions } from "firebase/functions";
import { initializeAppCheck, ReCaptchaEnterpriseProvider } from "firebase/app-check";

const firebaseApp = initializeApp({
  apiKey: "AIzaSyDwIaeuRelsVLZf8i6LMc2pf3q05fAZdo0",
  authDomain: "mvelio.firebaseapp.com",
  projectId: "mvelio",
  storageBucket: "mvelio.firebasestorage.app",
  messagingSenderId: "1023006148268",
  appId: "1:1023006148268:web:a8cb1578d9a33bc8174109"
});

export const auth = getAuth(firebaseApp);
export const db = initializeFirestore(firebaseApp, {
  experimentalForceLongPolling: true,
});
export const storage = getStorage(firebaseApp);
export const functions = getFunctions(firebaseApp);
initializeAppCheck(firebaseApp, {
  provider: new ReCaptchaEnterpriseProvider('6LeDBoUtAAAAADtSrtD48jD0APnagKf-4exrZzdG'), 
  isTokenAutoRefreshEnabled: true 
});
